import classNames from 'classnames';
import { Fragment, ReactElement } from 'react';

// Components.
import { DashboardWidget, IDashboardWidgetProps } from 'components/Dashboard';
import { DashboardBreakdownSection } from './DashboardBreakdownSection';
import { DashboardChartSection } from './DashboardChartSection';
import { DashboardFooterSection } from './DashboardFooterSection';
import { DashboardMetricSection } from './DashboardMetricSection';
import { DashboardVideoSection } from './DashboardVideoSection';

// Store.
import { DashboardSectionTypes, IDashboardBlock } from 'store/dashboard/types';

// Styles.
import styles from './DashboardDataWidget.module.scss';

interface IDashboardDataWidgetProps extends IDashboardWidgetProps {
  data: IDashboardBlock;
}

export const DashboardDataWidget = (props: IDashboardDataWidgetProps): ReactElement => {
  const { data, className, overrideCssClassName, ...widgetProps } = props;
  const { sections, links } = data || {};
  const cssClassName = !overrideCssClassName ? styles.widget : styles[overrideCssClassName];
  const widgetClassNames = classNames(cssClassName, className);

  return (
    <DashboardWidget className={widgetClassNames} overrideCssClassName={overrideCssClassName} {...widgetProps}>
      <div className={styles.sections}>
        {sections?.map((section, index) => (
          <Fragment key={index}>
            {section.type === DashboardSectionTypes.Chart && <DashboardChartSection {...section} />}
            {section.type === DashboardSectionTypes.Breakdown && <DashboardBreakdownSection {...section} />}
            {section.type === DashboardSectionTypes.Metric && <DashboardMetricSection {...section} />}
            {section.type === DashboardSectionTypes.Video && <DashboardVideoSection {...section} />}
          </Fragment>
        ))}
      </div>
      <DashboardFooterSection links={links} />
    </DashboardWidget>
  );
};
